module.exports = ".urls-list {\n  width: 100%;\n  outline: none; }\n"